// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__HSibV","arrows":"styles_arrows__3ki_Y","leftDigitStyle":"styles_leftDigitStyle__1CO_f","itemContainer":"styles_itemContainer__1SdN7"};